module.exports = __webpack_public_path__ + "static/media/tienda-naranja-viajes-logo-full.2dabd661.svg";